import API from '../../services/API'

export async function getEventActions(ctx: any, { lang, eventId, publicParticipantId }: any = {}) {
    lang = lang || 'fr'

    if (!eventId) {
        throw new Error('dispatch getEventActions(), missing "eventId"')
    }

    try {
        ctx.commit('SET_LOADING', { eventActions: true })
        const actions = await API.getEventActions(
            eventId,
            publicParticipantId || window.sessionStorage.getItem('publicParticipantId'),
            lang
        )
        ctx.commit('SET_LOADING', { eventActions: false })
        await ctx.commit('SET_EVENT_ACTIONS', { actions })

        return actions
    } catch (e) {
        ctx.commit('SET_LOADING', { eventActions: false })
        console.error(e)
        throw e
    }
}

export async function getSuggestedEvents(ctx: any) {
    const suggestedEvents = await API.getSuggestedEventList()
    ctx.commit('SET_SUGGESTED_EVENTS', { suggestedEvents })

    return suggestedEvents
}

export async function getMyEvents(ctx: any) {
    const myEvents = await API.getMyEvents()
    ctx.commit('SET_MY_EVENTS', { myEvents })

    return myEvents.data
}

export async function getUpcomingEvents(ctx: any, params: any) {
    const upcomingEventsResults = await API.searchPhysicalEvents({ ...params })
    ctx.commit('SET_UPCOMING_EVENTS', {
        events: upcomingEventsResults.results,
        totalResultCount: upcomingEventsResults.nbResults,
    })

    return upcomingEventsResults.results
}

export async function getMoreUpcomingEvents(ctx: any, { page }: any) {
    const upcomingEventsResults = await API.getUpcomingEvents({ page })
    console.log({ upcomingEventsResults })
    if (page === 1) {
        ctx.commit('SET_UPCOMING_EVENTS', {
            events: upcomingEventsResults.results,
            totalResultCount: upcomingEventsResults.nbResults,
        })
    } else {
        ctx.commit('APPEND_UPCOMING_EVENTS', {
            events: upcomingEventsResults.results,
            totalResultCount: upcomingEventsResults.nbResults,
        })
    }

    return upcomingEventsResults.results
}

export async function getPastEvents(ctx: any, { page }: any = {}) {
    const pastEventsResults = await API.getPastEvents(page)

    if (!page || page === 1) {
        ctx.commit('SET_PAST_EVENTS', {
            events: pastEventsResults.results,
            totalResultCount: pastEventsResults.nbResults,
        })
    } else {
        ctx.commit('APPEND_PAST_EVENTS', {
            events: pastEventsResults.results,
            totalResultCount: pastEventsResults.nbResults,
        })
    }

    return pastEventsResults.results
}

export async function getEventListsFromPage(ctx: any) {
    await Promise.all([
        ctx.dispatch('getSuggestedEvents'),
        ctx.dispatch('getMyEvents'),
        // ctx.dispatch('getUpcomingEvents'),
        ctx.dispatch('getPastEvents'),
    ])

    return true
}

export async function searchPhysicalEvents(ctx: any, { more }: any = {}) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    if (more) {
        searchParameters.page = ctx.state.searchedEvents.physicalEvents.currentPage + 1
    }

    try {
        ctx.commit('SET_LOADING', { physicalEvents: true })
        const physicalResults = await API.searchPhysicalEvents(searchParameters)

        if (more) {
            physicalResults.results = [...ctx.state.searchedEvents.physicalEvents.results, ...physicalResults.results]
        }

        ctx.commit('SET_PHYSICAL_SEARCHED_EVENTS', physicalResults)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { physicalEvents: false })
    }
}

export async function searchPhysicalEventsInHub(ctx: any, { more }: any = {}) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    if (more) {
        searchParameters.page = ctx.state.searchedEvents.physicalEventsInHub.currentPage + 1
    }
    searchParameters.hub = 'inHub'
    try {
        ctx.commit('SET_LOADING', { physicalEventsInHub: true })
        const physicalResults = await API.searchPhysicalEvents(searchParameters)

        if (more) {
            physicalResults.results = [
                ...ctx.state.searchedEvents.physicalEventsInHub.results,
                ...physicalResults.results,
            ]
        }

        ctx.commit('SET_PHYSICAL_IN_HUB_SEARCHED_EVENTS', physicalResults)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { physicalEventsInHub: false })
    }
}
export async function searchPhysicalEventsOutHub(ctx: any, { more }: any = {}) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    if (more) {
        searchParameters.page = ctx.state.searchedEvents.physicalEventsOutHub.currentPage + 1
    }
    searchParameters.hub = 'outHub'
    try {
        ctx.commit('SET_LOADING', { physicalEventsOutHub: true })
        const physicalResults = await API.searchPhysicalEvents(searchParameters)

        if (more) {
            physicalResults.results = [
                ...ctx.state.searchedEvents.physicalEventsOutHub.results,
                ...physicalResults.results,
            ]
        }

        ctx.commit('SET_PHYSICAL_OUT_HUB_SEARCHED_EVENTS', physicalResults)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { physicalEventsOutHub: false })
    }
}

export async function searchStreamingEvents(ctx: any, { webinar, more }: any = {}) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    if (webinar) {
        searchParameters.webinar = true
    }

    if (more) {
        searchParameters.page = ctx.state.searchedEvents.streamingEvents.currentPage + 1
    }

    try {
        ctx.commit('SET_LOADING', { streamingEvents: true })
        const streamingResults = await API.searchStreamingEvents(searchParameters)

        if (more) {
            streamingResults.results = [
                ...ctx.state.searchedEvents.streamingEvents.results,
                ...streamingResults.results,
            ]
        }

        ctx.commit('SET_STREAMING_SEARCHED_EVENTS', streamingResults)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { streamingEvents: false })
    }
}

export async function searchPastEvents(ctx: any, { webinar, more }: any = {}) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    if (webinar) {
        searchParameters.webinar = true
    }

    if (more) {
        searchParameters.page = ctx.state.searchedEvents.pastEvents.currentPage + 1
    }

    try {
        ctx.commit('SET_LOADING', { pastEvents: true })
        const pastResults = await API.searchPastEvents(searchParameters)

        if (more) {
            pastResults.results = [...ctx.state.searchedEvents.pastEvents.results, ...pastResults.results]
        }

        ctx.commit('SET_PAST_SEARCHED_EVENTS', pastResults)
    } catch (e) {
        Promise.reject(e)
    } finally {
        ctx.commit('SET_LOADING', { pastEvents: false })
    }
}

export async function searchEvents(ctx: any) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    ctx.commit('SET_LOADING', {
        physicalEvents: true,
        streamingEvents: true,
        pastEvents: true,
        physicalEventsInHub: true,
        physicalEventsOutHub: true,
    })

    ctx.dispatch('searchPhysicalEvents')
    ctx.dispatch('searchStreamingEvents')
    ctx.dispatch('searchPastEvents')
    ctx.dispatch('searchPhysicalEventsInHub')
    ctx.dispatch('searchPhysicalEventsOutHub')

    return []
}

export async function searchLiveAndReplayEvents(ctx: any) {
    const searchParameters = { ...ctx.state.searchParameters }
    searchParameters.businessCenters = searchParameters.businessCenters.map((bc: any) => bc.name)

    ctx.commit('SET_LOADING', { streamingEvents: true, pastEvents: true })

    ctx.dispatch('searchStreamingEvents', { webinar: true })
    ctx.dispatch('searchPastEvents', { webinar: true })

    return []
}
